import {StringKeyed} from "../../../../types/GenericTypes";
import {PlaceOrderRequest} from "../services/models/PlaceOrderRequest";

export interface OrderVettingResponse {
    readonly costOfTrade: number;
    readonly changeInCollateral: number;
    readonly premiumChange: number;
    readonly brokerage: number;
    readonly brokerageTax: number;
    readonly fees: number;
    readonly feesTax: number;
    readonly changeInMargin: number;
    readonly changeInScan: number;
    readonly addMargin: number;
    readonly changeInIC: number;
    readonly netEffect: number;
    readonly currentShortage: number;
    readonly whatIfShortage: number;
    readonly nlv: number;
    readonly lepoMtm: number;
    readonly utilisation: number;
    readonly utilisationPct: number;
    readonly utilisationClamped: number;
    readonly totalMargin: number;
    readonly shortageAdjustment: number;
    readonly tradePremiums: ReadonlyArray<Premium>;
    readonly scenarioSummary: ScenarioSummary;
    readonly hasCma: boolean;
    readonly vettingOutcomes: VettingOutcomes;
    readonly placeOrderRequest: PlaceOrderRequest;
    readonly accountName: string;
    readonly accountNumber: string;
}

export interface Premium {
    readonly code: string;
    readonly price: number;
    readonly premium: number;
}

export interface ScenarioSummary {
    readonly totalPremium: number;
    readonly totalCost: number;
    readonly currentBalance: number;
    readonly whatIfBalance: number;
    readonly clientMargin: number;
    readonly changeInCash: number;
    readonly fees: TradeFees;
}

export interface TradeFees {
    readonly brokerage: number;
    readonly brokerageTax: number;
    readonly fees: number;
    readonly feesTax: number;
}

export interface VettingOutcomes {
    readonly outcomes: ReadonlyArray<VettingOutcome>;
    readonly errors: boolean;
    readonly warnings: boolean;
    readonly count: number;
}

export interface VettingOutcome {
    readonly outcomeType: OutcomeType;
    readonly level: VettingLevel;
    readonly message: VettingMessage;
}

export interface VettingMessage {
    readonly code: string;
    readonly parameters: StringKeyed<string>;
}

export enum VettingLevel {
    OK = "OK",
    WARNING = "WARNING",
    ERROR = "ERROR"
}

export enum OutcomeType {
    BASE_MARGIN = "BASE_MARGIN",
    MARKET_UP_MARGIN = "MARKET_UP_MARGIN",
    MARKET_DOWN_MARGIN = "MARKET_DOWN_MARGIN",
    MARKET_DOWN_STEL = "MARKET_DOWN_STEL",
    MARKET_UP_NLV = "MARKET_UP_NLV",
    MARKET_DOWN_NLV = "MARKET_DOWN_NLV",
    MARKET_DOWN_BUYING_POWER = "MARKET_DOWN_BUYING_POWER",
    NO_CMA = "NO_CMA",
    BASE_CMA = "BASE_CMA",
    GAME_CLOSED = "GAME_CLOSED",
    ETR = "ETR",
    SHORT_SELL = "SHORT_SELL",
    GENERAL_ERROR = "GENERAL_ERROR",
    STAFF_ACCOUNT = "STAFF_ACCOUNT",
    SMALL_ORDER_PARCEL = "SMALL_ORDER_PARCEL"
}
